import { render, staticRenderFns } from "./SelfEvaluationColorbar.vue?vue&type=template&id=dacd5d2c"
import script from "./SelfEvaluationColorbar.vue?vue&type=script&lang=js"
export * from "./SelfEvaluationColorbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports